/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_SyncInputs */

const en_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Sync`)
};

const fr_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation automatique`)
};

const de_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Synchronisierung`)
};

const it_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione automatica`)
};

const ru_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая синхронизация`)
};

const es_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización automática`)
};

const zh_cn2_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动同步`)
};

const ja_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動同期`)
};

const hi_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित सिंक`)
};

const pt_pt2_automatic_sync = /** @type {(inputs: Automatic_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização automática`)
};

/**
* | output |
* | --- |
* | "Automatic Sync" |
*
* @param {Automatic_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_sync = /** @type {((inputs?: Automatic_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_sync(inputs)
	if (locale === "de") return de_automatic_sync(inputs)
	if (locale === "it") return it_automatic_sync(inputs)
	if (locale === "ru") return ru_automatic_sync(inputs)
	if (locale === "es") return es_automatic_sync(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_sync(inputs)
	if (locale === "ja") return ja_automatic_sync(inputs)
	if (locale === "hi") return hi_automatic_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_sync(inputs)
	return en_automatic_sync(inputs)
});